import React, { useEffect, useState } from 'react'
import styles from './style.module.scss';
import Header from '../Header'
import Sidebar, { TabPanel } from '../components/Sidebar';
import { tabList, tabItems } from './staticFile';
import { useDispatch, useSelector } from 'react-redux';
import { setGoogleTvTestDriveMenuItem } from '../../../store/actions/taskAction';
import { useLocation } from "react-router-dom"

const MainScreen = () => {
  const [value, setValue] = useState(1);
  const [isOpen, setIsOpen] = useState(false);
  const [isActiveSidebar, setActiveSidebar] = useState(false);
  const states = useSelector(state => state.task);
  const dispatch = useDispatch();
  const sampleLocation = useLocation();

	const toggle = () => setIsOpen(!isOpen);

  const onHover = (value) =>{
		setActiveSidebar(value)
	}

  return (
    <div className={`${styles.goolge_tv_waiting_room__main__screen} d-flex flex-column h-100`}>
        <Header isOperatoryRoom={true}/>  
        <div className={`${isActiveSidebar ? 'activeNav' : '' } navGoogleTvSidebar `}>
          <div className="d-flex flex-column navSidebar__inner h-100  pt-5" onMouseEnter={() => onHover(true)} onMouseLeave={() => onHover(false)}>
            <h2 className={`${isActiveSidebar ? 'visible' : 'invisible' } mb-5 mt-5 pt-5 pl-5 pl-5`}>{'Chairside Education'}</h2>
            <div className="navSidebar__tabItem" >
                <Sidebar
                  value={states.googleTvTestDriveChairsideMenuItem}
                  setValue={setValue}
                  tabList={tabList}
                  onClick={toggle}
                  isChairside={true}
                />
            </div>
          </div>
        </div>
      <div className={`${states.googleTvTestDriveChairsideMenuItem == 1 ? 'home' : ''} tabcontent` }>
        {tabItems.map((item, index) => (
          <TabPanel
            value={states.googleTvTestDriveChairsideMenuItem}
            index={index}
            key={index}
            >
            {item.component}
          </TabPanel>
        ))}
      </div>
    </div>
  )
}

export default MainScreen
